var site = site || {};

site.direction = site.direction || {};

(function ($) {
  Drupal.behaviors.offersEveryday = {
    attach: function (context) {
      var $module = $('.offers-everyday__items', context);
      var currentBreakpoint = Unison.fetch.now().name;

      if (currentBreakpoint != 'small') {
        $module.slick({
          rtl: site.direction.isRTL,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          onInit: function () {
            this.$slider.show();
          }
        });
      }
    }
  };
})(jQuery);
